import { isWebView } from "@utils/commonUtils";

export const appWebViewAuthFlow = (payload: any) => {

  if (typeof window === "undefined") return;

  const isApp =
    isWebView() && window?.flutter_inappwebview?.callHandler;

  if (!isApp) {
    return;
  }

  const hostUrl = (
    process.env.HOST_URL ||
    window.location.origin ||
    "https://www.acko.com"
  ).replace(/\/$/, "");

  const buildFreshCarLoginNextDeeplink = () => {
    const isnPath = process.env.NEXT_PUBLIC_ISNP_BASE_PATH || "/gi";
    const url = new URL(
      `${isnPath}/auto-storefront/fresh-car/checkout-review`,
      hostUrl
    );
    url.searchParams.set("current_node", "checkout_review_node");
    const searchParams = new URL(window.location.href).searchParams;
    const reg = searchParams.get("registration_number");
    const ekey = searchParams.get("proposal_ekey");
    if (reg) {
      url.searchParams.set("registration_number", reg);
    }
    if (ekey) {
      url.searchParams.set("proposal_ekey", ekey);
    }
    url.searchParams.set("redirect_from_app", "true");
    return url.toString();
  };

  const buildNewCarLoginNextDeeplink = () => {
    const isnPath = process.env.NEXT_PUBLIC_ISNP_BASE_PATH || "/gi";
    const url = new URL(
      `${isnPath}/auto-storefront/new-car/checkout`,
      hostUrl
    );
    url.searchParams.set("current_node", "checkout_node");
    const searchParams = new URL(window.location.href).searchParams;
    const ekey = searchParams.get("proposal_ekey");
    if (ekey) {
      url.searchParams.set("proposal_ekey", ekey);
    }
    return url.toString();
  };

  const isFreshCar = window.location.pathname.includes("/fresh-car");
  const isNewCar = window.location.pathname.includes("/new-car");
  const url = new URL(window.location.href);

  const nextDeeplink = payload?.nextDeeplink ||
    (isFreshCar
      ? buildFreshCarLoginNextDeeplink()
      : isNewCar
        ? buildNewCarLoginNextDeeplink()
        : url.toString());

  window.flutter_inappwebview.callHandler(
    "WebViewConnect",
    JSON.stringify({
      action: "login",
      action_value: {
        phone_number: payload?.phone,
        next: nextDeeplink
      }
    })
  );
};
